// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ArticleSearch":"baw_a bhs_ea bhs_sn","ArticleSearch__items":"baw_b bhs_tg","ArticleSearch__item":"baw_c bhs_th"};